import { useEffect, useState } from "react"

import { useTranslation } from "react-i18next"

import type { FieldUpdatePayload, FieldValue } from "../../types"

import { Button } from "@/components/ui/button"
import { Textarea } from "@/components/ui/textarea"

import { COMPANY_NAME } from "../../utils/branding"
import { FieldValueView } from "../plan/plan-field"
import { fieldToText } from "../plan/plan-utils"

/**
 * §06 Existing relationships with the tenant company — manual only. There is NO Update here;
 * the value is authored by hand and saved via the dedicated PUT endpoint.
 */
export function ManualRelationshipsSection({
  field,
  canEdit,
  isSaving,
  onSave,
}: {
  field: FieldValue
  canEdit: boolean
  isSaving: boolean
  onSave: (payload: FieldUpdatePayload) => void
}) {
  const { t } = useTranslation()
  const [draft, setDraft] = useState(fieldToText(field))

  useEffect(() => {
    setDraft(fieldToText(field))
  }, [field])

  if (!canEdit) {
    return <FieldValueView field={field} />
  }

  return (
    <div className="space-y-2">
      <Textarea
        className="min-h-32 text-sm"
        data-testid="sa-plan-manual-textarea"
        value={draft}
        placeholder={t("segmentAnalysis.manualSection.placeholder", {
          organization: COMPANY_NAME,
        })}
        onChange={(event) => setDraft(event.target.value)}
      />
      <div className="flex justify-end">
        <Button
          data-testid="sa-plan-manual-save"
          disabled={isSaving || draft === fieldToText(field)}
          size="sm"
          onClick={() => onSave({ value: draft, edited: true })}
        >
          {t("segmentAnalysis.manualSection.save")}
        </Button>
      </div>
    </div>
  )
}
